// extracted by mini-css-extract-plugin
export default {"section":"section-module--section--YiRvb","content":"section-module--content--nQ61b"};